/**
 * Whether a donation is part of the V1 claim year once the donor has marked
 * that year as sent to HMRC. There is no donation-level API yet, so this is
 * derived from the claim profile plus Gift Aid and tax-year membership.
 */

import type { DonorDonation } from '@/types/donorFinancialYear'
import type { ClaimTaxBackProfile } from '@/types/claimTaxBack'
import { donationInTaxYearPeriod } from '@/helpers/taxPackDonations'
import { isGiftAidedDonation } from '@/helpers/claimTaxBack/givenTotal'

export function isDonationIncludedInClaim(
  donation: DonorDonation,
  profile: ClaimTaxBackProfile | null
): boolean {
  if (!profile?.claimed || !profile.periodKey) return false
  return (
    isGiftAidedDonation(donation) &&
    donationInTaxYearPeriod(donation, profile.periodKey)
  )
}
